import './Explorer.scss';

import React from 'react';
import ReviewList from "../components/ReviewList";
import ReviewStatistics from "../components/ReviewStatistics";
import ClubSelectorDropdown from "../../../components/dropdown/clubselector/ClubSelectorDropdown";
import FilterSidePanel from "../components/FilterSidePanel";

interface Props {

}

const Explorer = ({}: Props) => {

    return (
        <>
            <div className={"explorer-heading-container"}>
                <div>
                    <h5 className={"heading explorer-heading"}>Reviews</h5>
                </div>
                <div className={"dashboard-welcome-club-dropdown-container"}>
                    <ClubSelectorDropdown/>
                </div>
            </div>

            <ReviewStatistics/>
            <ReviewList/>

            <FilterSidePanel />
        </>
    )
}

export default Explorer;